import React from "react";
import ImageDiv from "../image-div";
import classes from "./productImageSlider.module.scss";

const ProductImageSlider = (props) => {
  const { imageArr = [], itemName } = props;
  const exts = [".png", ".jpg", ".webp", ".gif", ".jpeg"];

  const imageSources = imageArr.filter((asset) => {
    if (typeof asset !== "string") return false;
    const cleanAsset = asset.split("?")[0];
    const ext = cleanAsset
      .substring(cleanAsset.lastIndexOf("."))
      .toLowerCase();
    return exts.includes(ext);
  });

  const img_fallback = (event) => {
    event.target.parentNode.childNodes.forEach(function (node) {
      if (node.nodeName == "IMG") node.src = window.no_image;
    });
  };

  if (imageSources.length === 0) {
    return (
      <div className={`${classes.sliderWrapper} ${props.wrapClass}`}>
        <div
          className={`${classes.sliderRoot} ${classes.sliderSkeleton}`}
          aria-hidden="true"
        />
      </div>
    );
  }

  return (
    <div className={`${classes.sliderWrapper} ${props.wrapClass}`}>
      <div className={`${classes.sliderRoot} uk-position-relative`} data-uk-slider="finite: true">
        <div className={`${classes.slider_container} uk-slider-container`} data-uk-lightbox>
          <ul className={`uk-slider-items uk-child-width-1-1 ${classes.sliderItems}`}>
            {imageSources.map((image, index) => (
              <li key={`${image}-${index}`} className={classes.slide}>
                <a href={image} className={classes.imageWrap}>
                  <ImageDiv imageUrl={`${image}?resize=998,998&compress=50`}>
                    <img
                      src={`${image}?resize=998,998&compress=50`}
                      alt={itemName}
                      width="998"
                      height="998"
                      onError={img_fallback}
                      loading={index === 0 ? "eager" : "lazy"}
                      fetchPriority={index === 0 ? "high" : "low"}
                      decoding="async"
                    />
                  </ImageDiv>
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className={classes.arrow}>
          <a
            className={classes.leftArrow}
            href="#"
            // data-uk-slidenav-previous
            data-uk-slider-item="previous"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
              <path d="M6.8932 1.69812C6.97686 1.42768 7.26393 1.27626 7.53438 1.35992C7.80482 1.44358 7.95624 1.73065 7.87258 2.00109L7.38289 1.84961L6.8932 1.69812ZM1.74445 8.00064V8.51323H-5.72205e-06L1.46715 7.56953L1.74445 8.00064ZM1.74445 8.00064V7.48805H16.6094V8.00064V8.51323H1.74445V8.00064ZM3.63366 6.78547L3.91096 7.21658L2.02174 8.43175L1.74445 8.00064L1.46715 7.56953L3.35637 6.35437L3.63366 6.78547ZM7.38289 1.84961L7.87258 2.00109C7.20727 4.15179 5.80435 5.99873 3.91096 7.21658L3.63366 6.78547L3.35637 6.35437C5.04675 5.2671 6.29923 3.61821 6.8932 1.69812L7.38289 1.84961Z" fill="white" />
              <path fillRule="evenodd" clipRule="evenodd" d="M4.21881 11C5.38558 11.8771 6.31339 13.0337 6.91607 14.3633C7.03293 14.6211 7.33698 14.7349 7.59478 14.6182C7.85226 14.5012 7.96626 14.1981 7.84966 13.9404C7.3498 12.8377 6.64975 11.8414 5.78912 11H4.21881Z" fill="white" />
            </svg>

          </a>
          <a
            className={classes.rightArrow}
            href="#"
            // data-uk-slidenav-next
            data-uk-slider-item="next"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
              <path d="M9.71624 1.69812C9.63257 1.42768 9.34551 1.27626 9.07506 1.35992C8.80461 1.44358 8.65319 1.73065 8.73686 2.00109L9.22655 1.84961L9.71624 1.69812ZM14.865 8.00064V8.51323H16.6094L15.1423 7.56953L14.865 8.00064ZM14.865 8.00064V7.48805H0V8.00064V8.51323H14.865V8.00064ZM12.9758 6.78547L12.6985 7.21658L14.5877 8.43175L14.865 8.00064L15.1423 7.56953L13.2531 6.35437L12.9758 6.78547ZM9.22655 1.84961L8.73686 2.00109C9.40217 4.15179 10.8051 5.99873 12.6985 7.21658L12.9758 6.78547L13.2531 6.35437C11.5627 5.2671 10.3102 3.61821 9.71624 1.69812L9.22655 1.84961Z" fill="white" />
              <path fillRule="evenodd" clipRule="evenodd" d="M12.3906 11C11.2239 11.8771 10.296 13.0337 9.69336 14.3633C9.5765 14.6211 9.27246 14.7349 9.01465 14.6182C8.75718 14.5012 8.64317 14.1981 8.75977 13.9404C9.25963 12.8377 9.95969 11.8414 10.8203 11H12.3906Z" fill="white" />
            </svg>
          </a>

        </div>
        <ul className={`uk-slider-nav uk-dotnav ${classes.dotNav}`}></ul>
      </div>
    </div>
  );
};

export default ProductImageSlider;
